import { createRoot } from "react-dom/client"

import { useI18nStore } from "@/locales"
import textCommon from "@/locales/zh-CN.json"
import { sdkReady } from "@/utils/sdk"
import { Root } from "../.."
import { IRelic, IRelicGroup, useTopicI18nStore } from ".."
import enemyList from "./json/enemy.json"
import game from "./json/game.json"
import gameRandomDict from "./json/gameRandom.json"
import other from "./json/other.json"
import record from "./json/record.json"
import relicGroups from "./json/relic.json"
import resultRhodes from "./json/resultRhodes.json"
import text from "./json/text.json"
import { TOPIC_STORE } from "./store"

const relicDict = relicGroups.reduce(
    (acc, group) => {
        group.items.forEach((item) => {
            acc[item.id] = item
        })
        return acc
    },
    {} as Record<string, IRelic>
)

useI18nStore.setState({
    text: {
        ...textCommon,
        ...text,
        ...game,
        ...other,
        ...record,
    },
    sdkReady,
    collect: (...params) => {
        sdkReady((sdk) => sdk.ETL.event(...params))
    },
})
useTopicI18nStore.setState({
    ...TOPIC_STORE,
    objects: {
        ...TOPIC_STORE.objects,
        relicGroups: relicGroups as IRelicGroup[],
        relicDict: relicDict,
        gameRandomDict: gameRandomDict,
        resultRhodes: resultRhodes,
        enemyList,
    },
})

const container = document.getElementById("root")
if (container) {
    const root = createRoot(container)
    root.render(<Root />)
}
